const routeAbout = () => '/about';

export default routeAbout;
